import React from 'react';
import { useIntl } from 'react-intl';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFinished } from '@futrli/ui-components/components/sidebar/wizard/wizard-finished/wizard-finished';

interface ShareResourceUpdatedWizardScreenProps {
  onClose: () => void;
}

export const ShareResourceUpdatedWizardScreen = ({ onClose }: ShareResourceUpdatedWizardScreenProps) => {
  const intl = useIntl();

  return (
    <WizardScreen
      closeText={intl.formatMessage({ id: 'common.close', defaultMessage: 'Close' })}
      footerMode={FooterMode.CREATED}
      onCancel={onClose}
    >
      <WizardFinished
        text={intl.formatMessage({ id: 'sharing.updated', defaultMessage: 'Sharing settings saved' })}
      />
    </WizardScreen>
  );
};
